import {
	IonButton,
	IonCheckbox,
	IonCol,
	IonImg,
	IonItem,
	IonLabel,
	IonModal,
	IonRadio,
	IonRadioGroup,
	isPlatform,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import "../BookService/service_details.scss";
import ServicePill from "./servicePill";
import * as constants from "../../../constants";
import { ToastMessage } from "../../../utils/toastMessage";

import {
	deleteAddress,
	getFaqs,
	saveAddressRef,
	setDefAddress,
	storeCurrentLatLong,
	storeUserEditAddressId,
	storeUserMapAddress,
	updateVehicleDefaultAddress,
	getServiceDetails,
	saveWorkshopStandard,
	addItemToCart,
	getCartItemsList,
	getArticlesData,
	deleteArticleAndFAQs,
	saveServiceSearchData,
} from "../../../Store/Actions";
import { connect } from "react-redux";
import { PageHeaderWithLoc } from "./pageHeadWithLoc";
import { CommonPointsForEachService } from "../BodyPanel/commonPointsForEachService";
import AddOnModal from "../../../utils/addOnModal";

export const ServiceDetails: React.FC = (props: any) => {
	const { location = {}, FaqList } = props;
	const [selectedAddons, setSelectedAddons] = useState<any>([]);
	const [articleData, setArticleData] = useState<any>([]);
	const { state = {} } = location;
	const {
		service = {},
		pricing = {},
		addOnSections = [],
		serviceProviderWorkshopList = [],
	} = props.location.state;
	const { amount } = pricing;
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	React.useEffect(() => {
		// console.log("Service Deatils =============", state);

		const vMake = props.userVehiclesList.find(
			(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
		);

		async function fetchData() {
			if (!!props.sliderCatelogVehicleId) {
				await props.getServiceDetails(state.service.serviceId, {
					catalogVehicleId: props.sliderCatelogVehicleId,
					pricingSegment:
						!!props.settings.pricingSegment &&
						props.settings.pricingSegment.toLowerCase(),
					id: state.service.serviceId,
					clientName: constants.CLIENT_NAME,
					make: vMake.make,
				});
			}
		}
		fetchData();
	}, [props.sliderCatelogVehicleId]);

	React.useEffect(() => {
		// console.log("SERVICE DETAILS ..", state);
		// console.log("SERVICE DETAILS props..", props);
		return () => {
			props.deleteArticleAndFAQs();
		};
	}, []);

	React.useEffect(() => {
		if (
			Object.keys(state).includes("addOn") &&
			Object.keys(props.servicesDetails).length
		) {
			state.addOn.map((addOn: any) => {
				props.servicesDetails.addOnSections.map(async (ele: any) => {
					if (ele.selectionType === "Multiple") {
						const checkbox = ele.items.find(
							(item: any) => item.addOnId === addOn.addOnId
						);
						if (!!checkbox) {
							await setSelectedAddons([...selectedAddons, checkbox]);
						}
					} else {
						const radio = ele.items.find((item: any) => item.addOnId === addOn.addOnId);
						if (!!radio) {
							await setOilGrade(radio);
						}
					}
				});
			});
		}
	}, [props.location.state]);
	const addOn = !!props.servicesDetails.addOnSections
		? props.servicesDetails.addOnSections
		: [];
	const addon_arr = addOn
		.map((ele: any) => ele.items)
		.reduce((prev: any, cur: any) => {
			return prev.concat(cur);
		}, []);
	const [oilGrade, setOilGrade] = useState<any>({});
	const [showAddon, setShowAddon] = useState(false);

	const [selectedFaqIds, setselectedFaqIds] = useState<any>([]);
	const [tinderWidth, setTinderWidth] = useState(320);
	const [cardArr, setCardArr] = useState([
		{
			articleId: "2d9c0cca-cb72-4d5b-a8c3-3c049cc05705",
			title: "FirstArticle",
			shortDescription: "1st_ArticleShortDescription",
			displayColor: "#f83db5",
			webpageUrl: "https://en.wikipedia.org/wiki/Brake",
		},
		{
			articleId: "22c1e4c8-e484-4269-9e02-2819344d3c77",
			title: "SecondArticle",
			shortDescription: "2nd_ArticleShortDescription",
			displayColor: "#299000",
			webpageUrl: "https://en.wikipedia.org/wiki/Brake",
		},
		{
			articleId: "22c1e4c8-e484-4269-9e02-2819344d3c77",
			title: "ThirdArticle",
			shortDescription: "3nd_ArticleShortDescription",
			displayColor: "red",
			webpageUrl: "https://en.wikipedia.org/wiki/Brake",
		},
	]);

	var Tinder: any = null;
	const fetchFaqs = async () => {
		if (!!state.service.faqListId) await props.getFaqs(state.service.faqListId);
		if (!!state.service.articleListId) {
			const article = await props.getArticlesData({
				articleListId: state.service.articleListId,
				clientName: constants.CLIENT_NAME,
			});
			if (!!article) {
				await setArticleData(article.data);
			}
		}
	};

	const addToCart = async () => {
		// console.log("160 .....", props);
		try {
			if (
				props.service_data.map((ele: any) => ele.serviceId).includes(service.serviceId)
			) {
				//alert(constants.SERVICE_ALREADY_ADDED)
				throw Error(constants.SERVICE_ALREADY_ADDED);
			}
			const payload = {
				addOnsSelected: !!addOnSections ? [...selectedAddons, oilGrade] : [],
				appliedPrice: {
					amount: amount,
					currency: pricing.currency,
					model: props.settings.pricingSegment
						? props.settings.pricingSegment
						: pricing.model,
				},
				damageTypeId: service.damageTypeId || "",
				partId: service.partId || "",
				recommended: true,
				partDisplayName: "",
				serviceId: service.serviceId,
				workshopId:
					props.globalSettings.length &&
					props.globalSettings[0].workshopListingModel === "Segment"
						? ""
						: props.settings.workshopId || "",
			};
			// console.log("WID Check === 190 === ", payload);
			await props.addItemToCart(payload);
			await props.saveServiceSearchData({});
			await props.getCartItemsList();
			await props.history.push("/portal/book_service");
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	useEffect(() => {
		fetchFaqs();
	}, []);

	const remove = (index: any) => {
		Tinder.swipe();
		const a = document.getElementsByClassName("sc-bxivhb");
		a[a.length - Tinder.state.current].setAttribute("style", "display:none;");
		setCardArr([
			...cardArr.slice(0, index),
			...cardArr.slice(index, cardArr.length),
			cardArr[index],
		]);
	};

	function checkMediaQuery() {
		const mediaQuery = window.matchMedia("(max-width: 700px)");
		if (mediaQuery) {
			setTinderWidth(window.innerWidth - 0.25 * window.innerWidth);
		} else {
			setTinderWidth(window.innerWidth - 0.78 * window.innerWidth);
		}
	}
	window.addEventListener("resize", checkMediaQuery);

	const handleWorkshopQualityOrModel = () => {
		// console.log("227 .....", props);
		(props.globalSettings || []).length &&
		props.globalSettings[0].workshopListingModel === "Segment"
			? props.history.push({
					pathname: "/portal/workshop-quality",
					state: {
						...props.servicesDetails,
						serviceProviderWorkshopList: props.location.state.serviceProviderWorkshopList,
						workshopQuality: props.servicesDetails.pricing,
						addOn:
							props.servicesDetails.addOnSections.length &&
							props.servicesDetails.addOnSections.every(
								(ele: any) => ele.items.length > 0
							)
								? [...selectedAddons, oilGrade]
								: [],
					},
					fromServiceDetail: true,
			  })
			: props.history.push({
					pathname: "/portal/select-workshop",
					state: {
						...props.servicesDetails,
						serviceProviderWorkshopList: props.location.state.serviceProviderWorkshopList,
						workshopQuality: props.servicesDetails.pricing,
						addOn:
							props.servicesDetails.addOnSections.length &&
							props.servicesDetails.addOnSections.every(
								(ele: any) => ele.items.length > 0
							)
								? [...selectedAddons, oilGrade]
								: [],
					},
			  });
	};
	return (
		<IonCol className="middle_panle res_bg_color service_panel" size-md="6">
			{isPlatform("ios") && <div className="ios_statusbar_color" />}
			{Boolean(Object.keys(props.servicesDetails).length) && (
				<>
					<div className="sd_parent">
						<div className="service_panel_header">
							<PageHeaderWithLoc {...props} />
						</div>
						<div className="sd_heading_web">
							<PageHeading
								mainHeader="Service Details"
								navigation={props}
								cssClass="service_detail_heading"
							/>
						</div>
						<div
							className={
								isPlatform("ios") ? "service_panel_body sd_top100" : "service_panel_body"
							}
						>
							<div className="sd_pill">
								<ServicePill
									{...state}
									{...props}
									cssClass={"service-details-service-price"}
								/>
							</div>
							<div className="sd_mobile_service_parent">
								<div className="sd_mobile_serimg">
									<IonImg
										src={state.service.imageUrl || "/images/brake_image.svg"}
										className="sd_mob_serimg"
									/>
									<IonLabel className="sd_mobile_recom">{constants.RECOMMENDED}</IonLabel>
								</div>
								<div className="sd_mob_serdet">
									<IonLabel className="sd_mobile_sername">
										{props.servicesDetails.service.displayName}
									</IonLabel>
									<IonLabel className="sd_mobile_sershort">
										{props.servicesDetails.service.shortDescription}
									</IonLabel>
									{(props.servicesDetails.service.displayTags || []).map(
										(tag: any, ind: any) => (
											<div className="sd_mob_tag_con">
												<IonLabel className="sd_mob_tag_text">{tag}</IonLabel>
											</div>
										)
									)}
								</div>
							</div>
							<CommonPointsForEachService
								service={props.servicesDetails.service}
								showArticle={true}
								FaqList={props.FaqList}
								articlesData={props.articlesData}
							/>
						</div>
					</div>
					<div className="page-footer service_footer">
						<div className="sd_show_pricing">
							<IonLabel className="sd_pricing_text">
								{`${constants.PRICE_BASED_ON} ${
									props.servicesDetails.pricing.model.charAt(0).toUpperCase() +
									props.servicesDetails.pricing.model.slice(1)
								} ${constants.PRICING}`}
								{/* price based on standard pricing */}
							</IonLabel>
						</div>
						<div className="sd_show_cost">
							<div className="sd_col">
								<IonLabel className="sd_escost">{constants.ESTIMATED_COST}</IonLabel>
								<IonLabel className="sd_price">{`${constants.RupeeSymbol} ${Number(
									props.servicesDetails.pricing.amount
								)}`}</IonLabel>
							</div>
							<IonButton
								color="light"
								onClick={() => {
									if (
										props.servicesDetails.addOnSections.length &&
										props.servicesDetails.addOnSections.every(
											(ele: any) => ele.items.length > 0
										)
									) {
										setShowAddon(true);
									} else {
										if (!!props.service_data.length) {
											addToCart();
										} else {
											handleWorkshopQualityOrModel();
										}
									}
								}}
								className={
									!props.service_data.length
										? "service-details-continue-button"
										: "add_to_cart_btn"
								}
							>
								<IonLabel color="primary">
									{!!props.service_data.length
										? constants.ADD_TO_CART
										: constants.CONTINUE}
								</IonLabel>
							</IonButton>
						</div>
						<ToastMessage
							showToast={toast.showToast}
							ToastMessage={toast.toastMessage}
							severity={toast.severity}
							onDidDismiss={() => {
								setToast({
									showToast: false,
									toastMessage: "",
									severity: "",
								});
							}}
						/>
					</div>
				</>
			)}

			<AddOnModal
				showAddon={showAddon}
				oilGrade={oilGrade}
				selectedAddons={selectedAddons}
				setShowAddon={(value: boolean) => setShowAddon(value)}
				addOnSections={state.addOnSections}
				setOilGrade={(value: any) => {
					if (value.addOnId !== oilGrade.addOnId) {
						setOilGrade(value);
					} else {
						setOilGrade({});
					}
				}}
				setSelectedAddons={(value: any) => {
					const index = selectedAddons.findIndex(
						(ele: any) => ele.addOnId === value.addOnId
					);
					if (index < 0) {
						setSelectedAddons([...selectedAddons, value]);
					} else {
						setSelectedAddons(
							selectedAddons.filter((ele: any) => ele.addOnId !== value.addOnId)
						);
					}
				}}
				submitData={() => {
					setShowAddon(false);
					if (!!props.service_data.length) {
						addToCart();
					} else {
						handleWorkshopQualityOrModel();
					}
				}}
			/>
		</IonCol>
	);
};
export default connect(
	({
		userInfo,
		auth,
		cart: { service_data },
		workshop: { globalSettings },
		dashboard: { articlesData },
	}: any) => {
		const {
			FaqList,
			searchRecommendations,
			searchServices,
			searchTags,
			serviceSearch,
			userAddressList,
			userVehiclesList,
			sliderCatelogVehicleId,
			selectedAddressRef,
			servicesDetails,
		} = userInfo;
		return {
			FaqList,
			searchRecommendations,
			searchServices,
			searchTags,
			serviceSearch,
			userAddressList,
			userVehiclesList,
			sliderCatelogVehicleId,
			selectedAddressRef,
			servicesDetails,
			service_data,
			globalSettings,
			articlesData,
			...auth,
		};
	},
	{
		getFaqs,
		storeCurrentLatLong,
		storeUserMapAddress,
		updateVehicleDefaultAddress,
		deleteAddress,
		setDefAddress,
		storeUserEditAddressId,
		saveAddressRef,
		getServiceDetails,
		saveWorkshopStandard,
		addItemToCart,
		getCartItemsList,
		getArticlesData,
		deleteArticleAndFAQs,
		saveServiceSearchData,
	}
)(ServiceDetails);
